/** Soft cap: beyond this, live ReactMarkdown remounts get too expensive on mobile. */
const LIVE_MARKDOWN_MAX_CHARS = 4_000;

const TABLE_ROW_RE = /^\s*\|.+\|\s*$/;
const TABLE_SEPARATOR_RE = /^\s*\|?\s*:?-{3,}/;

/**
 * Live Connie streams keep Markdown for normal prose.
 * Once a GFM table (or a very large dump) appears, callers should throttle
 * Markdown commits instead of remounting on every paced tick.
 */
export function shouldRenderLiveMarkdown(content: string): boolean {
  if (!content) return true;
  if (content.length >= LIVE_MARKDOWN_MAX_CHARS) return false;
  return !hasGfmTableSignal(content);
}

function hasGfmTableSignal(content: string): boolean {
  const lines = content.split('\n');
  let pipeRows = 0;

  for (let index = 0; index < lines.length; index += 1) {
    const line = lines[index];
    if (!TABLE_ROW_RE.test(line)) continue;

    pipeRows += 1;
    const next = lines[index + 1];
    if (next && TABLE_SEPARATOR_RE.test(next)) {
      return true;
    }
  }

  // Mid-stream tables often arrive as several pipe rows before the separator
  // settles; treat that as heavy content too.
  return pipeRows >= 2;
}
